import { Component, inject } from "@angular/core";
import { AuthService } from "@app/auth.service";
import { UiKitModule } from "@app/ui-kit.module";
import { HeaderComponent, HeaderTitleDirective } from "@odx/angular/components/header";
import { LogoDirective } from "@odx/angular/components/logo";

@Component({
  selector: "app-external-user",
  imports: [HeaderComponent, HeaderTitleDirective, LogoDirective, UiKitModule],
  templateUrl: "./external-user.component.html",
  styleUrl: "./external-user.component.scss",
})
export class ExternalUserComponent {
  private authService = inject(AuthService);

  protected logOut() {
    this.authService.logout();
  }
}
